const invoiceMockedData = {
  user: {
    name: 'Dr Test User',
    email: 'user@example.com',
    phone: 'xxx-xxx-xxxx',
    address1: '123 address road',
    address2: '',
    city: 'Some City',
    province: 'Some Province',
    postalCode: 'S0S 1S1',
  },
  patient: {
    name: 'Test Patient',
    address1: '123 address road',
    address2: '',
    city: 'City',
    province: 'Province',
    postalCode: 'S0S 1S1',
    country: 'Canada',
  },
  claims: [
    {
      dateOfService: 1607086055,
      description: 'Some record description',
      code: 'C12345',
      privateBillingAmount: 123.55,
    },
    {
      dateOfService: 1607086055,
      description: 'Some record description2',
      code: 'C12345',
      privateBillingAmount: 123.55,
    },
  ],
  invoiceDetails: {
    number: 123,
    date: 1607363013330,
    terms: 'Payment must be paid, otherwise nothing happens :P',
  },
}

export default invoiceMockedData
